import 'reflect-metadata';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initServiceWorker, installChunkLoadRecovery } from './pwa';
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import "ag-grid-charts-enterprise";
import { LicenseManager } from "ag-grid-charts-enterprise";
import { AgCharts as AgChartsEnterprise } from "ag-charts-enterprise";
import './App.css';
import "./editor.css";

AgChartsEnterprise.setLicenseKey(process.env.VITE_AG_GRID_LICENSE_KEY!);
LicenseManager.setLicenseKey(process.env.VITE_AG_GRID_LICENSE_KEY!);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (process.env.NODE_ENV !== 'production') {
  loadDevMessages();
  loadErrorMessages();
}

// Înainte de prima randare: un chunk lazy care nu se mai găsește după un deploy reîncarcă
// pagina o dată, în loc să lase ecranul gol (vezi pwa.ts).
installChunkLoadRecovery();

root.render(
    <App />
);

// Service worker-ul se înregistrează după montarea aplicației, ca să nu concureze cu
// primul randare pentru bandă. Preluarea unei versiuni noi rămâne la comanda
// utilizatorului, prin popup-ul din VersionContext.
initServiceWorker();

// Custom CSS importat ULTIMUL pentru prioritate maximă
import("./custom.css");

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
